import { render, staticRenderFns } from "./TicketSimple.vue?vue&type=template&id=7b5c0e8b"
import script from "./TicketSimple.vue?vue&type=script&lang=js"
export * from "./TicketSimple.vue?vue&type=script&lang=js"
import style0 from "./TicketSimple.vue?vue&type=style&index=0&id=7b5c0e8b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports